<template>
	<div class="project-container">
	  <!-- Full-width centered header: Title, Authors, Subtitle -->
	  <div class="row">
		<div class="col-12 text-center desc-header">
		  <h2 class="proj-title" @click="redirectUrl(project.url)">
			{{ project.title }}
		  </h2>
		  <div class="authors" v-html="formattedAuthors"></div>
		  <div v-if="project.subtitle" class="subtitle">
			<b>{{ project.subtitle }}</b>
		  </div>
		</div>
	  </div>

	  <!-- Body: video/image (70%) on the left, text (30%) on the right -->
	  <div class="row align-items-start proj-body">
		<div class="col-12 proj-media">
		<div class="pf-picture">
			<video
			  v-if="isVideo"
			  class="pf-img"
			  :src="project.imageSrc"
			  autoplay
			  loop
			  muted
			  playsinline
			></video>
			<img
			  v-else
			  class="pf-img"
			  :src="project.imageSrc"
			  alt="Arthur Zhang"
			/>
		  </div>
		</div>

		<div class="col-12 proj-text">
		  <span class="proj-links">
			<a v-if="project.paper && project.paper.length > 0" :href="project.paper" target="_blank">[Paper]</a>
			<a v-if="project.url && project.url.length > 0" :href="project.url" target="_blank">[Website]</a>
		  </span>
		  {{ project.description }}
		</div>
	  </div>
	</div>
  </template>
  
  <script>
  import router from '../router'
  
  export default {
	name: 'Project',
	props: {
	  project: {
		type: Object,
		required: true
	  }
	},
	computed: {
	  formattedAuthors() {
		return this.project.authors.map((author, index) => {
		  let nameStyle = author.name === "Arthur Zhang" ? `<b>${author.name}</b>` : author.name;
		  let formattedName = `${nameStyle}<span class="superscript"><sup>${author.rank}</sup></span>`;
		  if (author.website) {
			formattedName = `<a href="${author.website}" target="_blank">${formattedName}</a>`;
		  }
		  return formattedName + (index < this.project.authors.length - 1 ? ', ' : '');
		}).join('');
	  },
	  isVideo() {
		return (
		  this.project.imageSrc &&
		  this.project.imageSrc.toLowerCase().endsWith('.mp4')
		);
	  }
	},
	methods: {
	  redirectUrl(url) {
		if (url.length === 0) return;
		window.open(url, '_blank');
	  }
	}
  };
  </script>
  
  <style scoped>
  .project-container {
	margin-bottom: 16px;
	padding-bottom: 16px;
	border-bottom: 1px solid #eee;
  }

  .desc-header {
	margin-bottom: 8px;
  }

  .proj-title {
	margin: 0 0 4px;
	font-weight: bold;
	font-size: 22px;
	cursor: pointer;
  }

  .authors {
	font-size: 15px;
	font-weight: bold;
  }

  .authors a {
	color: #3399ff;
	text-decoration: none;
  }

  .authors a:hover {
	text-decoration: underline;
  }

  .subtitle {
	font-weight: bold;
	margin-top: 2px;
  }

  .pf-img {
	width: 100%;
	height: auto;
	max-height: 250px;
	object-fit: contain;
  }

  .proj-text {
	text-align: left;
	font-size: 15px;
	line-height: 1.6;
	color: #333;
  }

  .proj-links a {
	color: #3399ff;
	text-decoration: none;
	margin-right: 4px;
  }

  .proj-links a:hover {
	text-decoration: underline;
  }

  .superscript sup {
	font-size: 60%;
  }

  /* Video 70% / text 30% on wide screens */
  @media screen and (min-width: 1000px) {
	.proj-media {
	  flex: 0 0 70%;
	  max-width: 70%;
	}
	.proj-text {
	  flex: 0 0 30%;
	  max-width: 30%;
	}
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/ProjectCard.vue